import axios from 'axios';
import { isLoading } from '@/store/loading';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
const SECRET_KEY = process.env.VUE_APP_SECRET_KEY;

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Secret-Key': SECRET_KEY,
  },
});

let requestCount = 0;

let showTimer = null;
let hideTimer = null;
let shownAt = 0;

const SHOW_DELAY = 0; // 100ms 안에 끝나면 로더 안 뜸
const MIN_SHOW = 1000; // 한번 뜨면 최소 1초 유지

function scheduleShow() {
  if (isLoading.value) return;

  clearTimeout(showTimer);
  clearTimeout(hideTimer);

  showTimer = setTimeout(() => {
    isLoading.value = true;
    shownAt = Date.now();
  }, SHOW_DELAY);
}

function scheduleHide() {
  clearTimeout(showTimer);

  const elapsed = Date.now() - shownAt;
  const remain = Math.max(0, MIN_SHOW - elapsed);

  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    isLoading.value = false;
  }, remain);
}

instance.interceptors.request.use(config => {
  requestCount += 1;
  scheduleShow();
  return config;
});

instance.interceptors.response.use(
  res => {
    requestCount = Math.max(0, requestCount - 1);
    if (requestCount === 0) scheduleHide();
    return res;
  },
  err => {
    requestCount = Math.max(0, requestCount - 1);
    if (requestCount === 0) scheduleHide();
    return Promise.reject(err);
  },
);

export const api = {
  get: (url, config = {}) => instance.get(url, config),
  post: (url, data = {}, config = {}) => {
    const body = {
      ...data,
      lang: 'ko',
      fmt: 'on',
      // test: 'on',
    };
    return instance.post(url, body, config);
  },
  put: (url, data = {}, config = {}) => instance.put(url, data, config),
  delete: (url, config = {}) => instance.delete(url, config),
};

export default api;
